import { EntryType } from 'src/lib/types/entries/EntryType'
import deepFreeze from 'deep-freeze'

export class NumberEntryType extends EntryType {
  constructor(entry) {
    super(entry)
    deepFreeze(this)
  }

  _getBasicSchema() {
    const schema = super._getBasicSchema()
    schema.properties.value.properties.type = { enum: ['number'] }
    schema.properties.value.properties.value = { type: 'number' }

    return schema
  }
}



// WEBPACK FOOTER //
// ./src/lib/types/entries/NumberEntryType.js